import DefaultMenu from 'common/DefaultMenu';
import MediaMenuSetur from 'common/MediaMenuSetur';
import SuperAdminMenu from 'common/SuperAdminMenu/temp';
import TourOrganizerMenu from 'common/TourOrganizerMenu';
import TouristMenu from 'common/TouristMenu';
import React from 'react';
import { getLocalUser } from 'services/localStorage';
import { Back, Container, HambLine, SideMenu } from './styles';
import MobileMenuItems from 'common/MobileMenuItems';
import MenuSetur from 'common/MenuSetur';
import MediaMenu from 'common/MediaMenu';
import TradeMenu from 'common/TradeMenu';
import MenuSeturMarket from 'common/MenuSeturMarket';
import MenuSeturMarketing from 'common/MenuSeturMarketing';
import MenuSeturFundetur from 'common/MenuSeturFundetur';
import MenuSeturAttorney from 'common/MenuSeturAttorney';
import MenuSeturExcursion from 'common/MenuSeturExcursion';
import MenuSeturDados from 'common/MenuSeturDados';

const HandleMobileMenu: React.FC = () => {
  const localUser = getLocalUser();

  const profileName = localUser?.profile?.name;

  const handleMenu = () => {
    switch (profileName) {
      case 'tour':
        return <TourOrganizerMenu />;
      case 'tourist':
        return <TouristMenu />;
      case 'news':
        return <MediaMenuSetur />;
      case 'news-external':
        return <MediaMenu />;
      case 'admin':
        return <SuperAdminMenu />;
      case 'setur':
        return <MenuSetur />;
      case 'setur-market':
        return <MenuSeturMarket />;
      case 'setur-marketing':
        return <MenuSeturMarketing />;
      case 'setur-fundetur':
        return <MenuSeturFundetur />;
      case 'setur-attorney':
        return <MenuSeturAttorney />;
      case 'setur-excursion':
        return <MenuSeturExcursion />;
      case 'setur-dados':
        return <MenuSeturDados />;
      case 'trade':
        return <TradeMenu />;
      default:
        return <DefaultMenu />;
    }
  };
  return (
    <Container>
      <input type="checkbox" id="side-menu" />
      <Back></Back>
      <HambLine htmlFor="side-menu">
        <span></span>
      </HambLine>
      <SideMenu>
        {handleMenu()}
        <MobileMenuItems />
      </SideMenu>
    </Container>
  );
};

export default HandleMobileMenu;
